module.exports = __webpack_public_path__ + "static/media/Explore-Illustration_1.b20a8984.svg";